// @flow

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import type { OperationComponent, QueryProps } from "react-apollo";

import type { UserTask } from "./user-results";

export const sessionResultsQuery = gql`
  query($projectId: ID, $userId: ID, $sessionId: ID) {
    allTasks(
      filter: {
        project: { id: $projectId }
        results_some: { user: { id: $userId } }
      }
    ) {
      id
      question
      answer
      responseTimesInSeconds
      results(
        filter: { user: { id: $userId }, session: { id: $sessionId } }
        orderBy: secondsLimit_ASC
      ) {
        id
        createdAt
        kind
        secondsElapsed
        secondsLimit
        confidence
      }
    }
  }
`;

export type sessionResultsQueryResult = {
  sessionResultsData: {
    allTasks?: Array<UserTask>
  } & QueryProps
};

export const withSessionResults: OperationComponent<
  sessionResultsQueryResult,
  { userId: string, sessionId: string, projectId: string }
> = graphql(sessionResultsQuery, {
  options: ({ userId, sessionId, projectId }) => {
    return {
      variables: { userId, sessionId, projectId },
      fetchPolicy: "network-only"
    };
  },
  name: "sessionResultsData"
});



// WEBPACK FOOTER //
// ./src/data/session-results.js